import {
  s3ControllerGetSignedUrl,
  type S3FoldersType,
  unwrapApiResponse,
} from "@cryptors/api-client";

export const getPutSignedURL = async (
  fileName: string,
  folder: S3FoldersType,
): Promise<string> =>
  unwrapApiResponse(
    s3ControllerGetSignedUrl<true>({
      query: { filename: fileName, folder },
      throwOnError: true,
    }),
  );
